export const getDayStart = (date = new Date()) => {
  const day = new Date(date)
  day.setHours(0, 0, 0, 0)
  return day
}

export const getShortcutTimeRange = (value) => {
  const today = getDayStart()
  if (value === 'today') {
    return [today.getTime(), today.getTime()]
  }
  if (value === 'week') {
    const day = today.getDay() || 7
    const monday = new Date(today)
    monday.setDate(today.getDate() - day + 1)
    const sunday = new Date(monday)
    sunday.setDate(monday.getDate() + 6)
    return [monday.getTime(), sunday.getTime()]
  }
  if (value === 'month') {
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1)
    const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0)
    return [monthStart.getTime(), monthEnd.getTime()]
  }
  return null
}
